<p-dialog styleClass="custom-modal" [visible]="visible" (visibleChange)="onChange($event)" [modal]="true"
    [showHeader]="true" [closeOnEscape]="false" [closable]="true">
    <ng-content></ng-content>
</p-dialog>